import React from "react";
import { useNavigate } from "react-router-dom";
import { WholeSaleMarketInfo } from "./DashboardDetailFooterStyle";

const DashboardDetailFooter = () => {
  const navigate = useNavigate();
  return (
    <WholeSaleMarketInfo>
      <p>‘장미’를 취급하는 도매상 목록이 궁금하다면?</p>
      <p>도매 시장 정보를 보고, 전화로 문의해 보세요!</p>
      <button onClick={() => navigate("/market")} style={{ cursor: "pointer" }}>
        도매 시장 정보 바로가기
      </button>
    </WholeSaleMarketInfo>
  );
};

export default DashboardDetailFooter;
